/* eslint-disable @typescript-eslint/no-explicit-any */
import { FatalError } from '../types/errors';
import { createAndCaptureError } from './createAndCaptureError';
export function promisefy<TArgs extends any[], TCallback extends (...args: any[]) => void>(
  fn: (...args: [...TArgs, TCallback]) => void
): (...args: TArgs) => Promise<Parameters<TCallback>[0]> {
  if (typeof fn !== 'function') {
    console.warn('Attempted to call a function which does not exist. window.host keys: ' + JSON.stringify(Object.keys(window.host || {})));

    throw createAndCaptureError(new FatalError('fn is not a function')).error;
  }

  return (...args: TArgs): Promise<Parameters<TCallback>[0]> => {
    return new Promise((resolve) => {
      fn(...args, ((callbackArg: Parameters<TCallback>[0]) => {
        resolve(callbackArg);
      }) as TCallback);
    });
  };
}
